// Anita Week 5 / Day 4 — ИИ помогает, но человек проверяет / AI Helps, Human Checks.

const day4 = {
  id: 'day-4',
  studentId: 'anita',
  weekId: 'week-5',
  dayId: 'day-4',
  status: 'active',
  title: 'ИИ помогает, но человек проверяет / AI Helps, Human Checks',
  shortTitle: 'ИИ + проверка / AI + Check',
  theme: 'Анита учится: ИИ полезен, но человек проверяет факты. / AI is useful, but a human checks facts.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'information-literacy', 'ai-literacy', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни: ИИ — это помощник, но проверять факты должен человек. / Nimny: AI helps, but a human verifies facts.',
  goals: ['Считать верные и неверные ответы ИИ.', 'Группировать ответы (6 × 5) + добавление.', 'Считать время проверки и вывода.', 'Найти лучший ответ по баллам.', 'Заполнить AI-check таблицу с 4 полями.'],
  vocabulary: [
    { term: 'ИИ / AI', definition: 'умный помощник в компьютере. / smart computer helper.' },
    { term: 'ответ / answer', definition: 'то, что даёт ИИ или человек. / what AI or a human gives.' },
    { term: 'проверить / to verify', definition: 'убедиться, что правильно. / make sure it is correct.' },
    { term: 'ошибка / mistake', definition: 'неправильный ответ. / wrong answer.' },
    { term: 'источник / source', definition: 'откуда пришла информация. / where info comes from.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова ИИ / AI Words',
      prompt: 'Прочитай:\nИИ\nответ\nпроверить\nошибка\nисточник',
      ruPrimaryText: 'Прочитай 5 слов.', enHelpText: 'Read 5 words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай:\nИИ — это умный помощник.\nИИ может ошибаться.\nЧеловек проверяет факты.\nМы всегда просим источник.\nМы делаем это с родителем.',
      ruPrimaryText: 'Прочитай 5 фраз про ИИ.',
      enHelpText: 'AI can make mistakes; a human verifies with a parent.',
      answer: 'Попытка чтения.' },
    { id: 'math-ai-fix', type: 'text', title: 'Задание 3 — Исправить ответы ИИ / Fix AI Answers',
      prompt: 'ИИ дал 50 ответов. 38 ответов были верными.\n\nОтветь:\n1. Сколько ответов нужно исправить?',
      ruPrimaryText: 'Простое вычитание.',
      enHelpText: 'Subtract 38 from 50.',
      answer: '1) 50 − 38 = 12 ответов.' },
    { id: 'math-ai-groups', type: 'text', title: 'Задание 4 — Группы ответов / Answer Groups',
      prompt: 'Анита проверила 6 групп ответов. В каждой группе по 5 ответов. Потом она нашла ещё 8 ответов.\n\nОтветь:\n1. Сколько ответов было в группах?\n2. Сколько ответов стало всего?',
      ruPrimaryText: 'Умножение × сложение.',
      enHelpText: 'Multiply 6 × 5; add 8.',
      answer: '1) 6 × 5 = 30. 2) 30 + 8 = 38.' },
    { id: 'math-ai-time', type: 'text', title: 'Задание 5 — Время проверки / Check Time',
      prompt: 'Проверка одного ответа — 3 минуты. Анита проверяет 12 ответов. Потом 9 минут пишет вывод.\n\nОтветь:\n1. Сколько минут ушло на проверку?\n2. Сколько времени всего?',
      ruPrimaryText: 'Умножение времени + добавление вывода.',
      enHelpText: 'Multiply 3 × 12; add 9.',
      answer: '1) 3 × 12 = 36. 2) 36 + 9 = 45 минут.' },
    { id: 'math-best-answer', type: 'text', title: 'Задание 6 — Лучший ответ / Best Answer',
      prompt: 'Первый ответ — 8 баллов, второй — 6, третий — 10.\n\nОтветь:\n1. Сколько баллов всего?\n2. Какой ответ лучший?',
      ruPrimaryText: 'Сумма 3 баллов + сравнение.',
      enHelpText: 'Sum and compare.',
      answer: '1) 8 + 6 + 10 = 24. 2) Третий (10 больше всех).' },
    { id: 'logic-ai-check-table', type: 'text', title: 'Задание 7 — Таблица проверки ИИ / AI-Check Table',
      prompt: 'ИИ дал ответ (без источника): «В Марсе всегда идёт дождь.»\n\nЗаполни таблицу:\n1. Что утверждается?\n2. Что надо проверить?\n3. Какой источник поможет?\n4. Можно ли сразу доверять?',
      ruPrimaryText: 'AI-check таблица из 4 полей.',
      enHelpText: 'Fill the 4-field AI-check table.',
      answer: 'Ожидаемо: 1) «На Марсе идёт дождь». 2) Есть ли дождь на Марсе; когда; каких видов. 3) Книга по астрономии или сайт NASA — вместе с родителем. 4) Нет, сразу доверять нельзя, нужно проверить.' },
    { id: 'spelling-day4', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\nИИ\nответ\nпроверить\nошибка\nисточник\n\nВставь буквы:\nо_вет\nпров_рить\nо_ибка\nис_очник',
      ruPrimaryText: 'Напиши слова и вставь буквы.',
      enHelpText: 'Write words and fill in letters.',
      answer: 'ИИ, ответ, проверить, ошибка, источник.' },
    { id: 'creative-ai-card', type: 'text', title: 'Задание 9 — Карточка проверки ИИ / AI-Check Card',
      prompt: 'Нарисуй карточку-проект: выдуманное утверждение ИИ + план проверки в 2 предложения.',
      ruPrimaryText: 'Карточка + 2 предложения плана проверки.',
      enHelpText: 'Draw a card with an AI claim and a plan to verify it.',
      answer: 'Open-ended.' },
    { id: 'speech-day4', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю:\nИИ помогает, но человек проверяет.\nЯ прошу источник.\nЯ проверяю ответ вместе с родителем.',
      ruPrimaryText: 'Объясни идею по-русски.',
      enHelpText: 'AI helps but human verifies; ask for source; verify with a parent.',
      answer: 'Accept if expressed in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Начерти AI-check таблицу из 4 колонок.',
    '2. Реши задачи 3–6.',
    '3. Напиши карточку проверки.',
    '4. Объясни родителю.'
  ],
  printWorksheet: {
    title: 'ИИ помогает, но человек проверяет / AI Helps, Human Checks',
    subtitle: 'Неделя 5 · День 4 / Week 5 · Day 4',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: ИИ помогает, но человек проверяет факты.' },
        { type: 'text', text: 'Задание 1 — Слова ИИ:' },
        { type: 'list', items: ['ИИ / AI', 'ответ / answer', 'проверить / verify', 'ошибка / mistake', 'источник / source'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
        { type: 'list', items: ['□ ИИ — умный помощник.', '□ ИИ может ошибаться.', '□ Человек проверяет факты.', '□ Мы просим источник.', '□ Мы делаем это с родителем.'] },
        { type: 'text', text: 'Задание 3 — Исправить ответы ИИ. 50 всего, 38 верных.' },
        { type: 'list', items: ['50 − 38 = ___ ответов исправить'] },
        { type: 'text', text: 'Задание 4 — Группы ответов:' },
        { type: 'list', items: ['6 × 5 = ___', '___ + 8 = ___ ответов всего'] }
      ] },
      { title: 'Время и AI-check таблица / Time and AI-Check', blocks: [
        { type: 'text', text: 'Задание 5 — Время проверки:' },
        { type: 'list', items: ['3 × 12 = ___ минут', '___ + 9 = ___ минут всего'] },
        { type: 'text', text: 'Задание 6 — Лучший ответ:' },
        { type: 'list', items: ['Ответ | Баллы', '  1   |  8', '  2   |  6', '  3   |  10', 'Всего: 8 + 6 + 10 = ___', 'Лучший ответ: ___'] },
        { type: 'text', text: 'Задание 7 — Таблица проверки ИИ. Готовая таблица:' },
        { type: 'list', items: [
          'Утверждение         | Что проверить  | Где проверить      | Можно доверять?',
          '«На Марсе идёт      | ___            | ___                | ___',
          'дождь.»             | ___            | ___                | ___'
        ] }
      ] },
      { title: 'Русский, проект и защита / Russian, Project, Defense', blocks: [
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['ИИ   ответ   проверить   ошибка   источник', '     о_вет    пров_рить    о_ибка    ис_очник'] },
        { type: 'text', text: 'Задание 9 — Карточка проверки ИИ. Нарисуй карточку-проект:' },
        { type: 'list', items: ['Утверждение ИИ: __________________________________________', 'Мой план проверки (2 предложения):', '1) __________________________________________', '2) __________________________________________'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю:' },
        { type: 'list', items: ['□ ИИ помогает.', '□ Человек проверяет.', '□ Я прошу источник.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ 50 − 38  □ 6 × 5 + 8  □ 3 × 12 + 9  □ лучший ответ  □ AI-check таблица  □ карточка  □ защита.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти AI-check таблицу и карточку в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    practicalGoal: 'Заполнить AI-check таблицу из 4 полей.',
    whatThisLessonTeaches: 'ИИ полезен, но правильность проверяет человек.',
    howToExplain: 'Скажите: не бывает «сразу доверять». Проверяем.',
    exampleDialogue: 'Parent: 50 − 38?\nChild: 12.\nParent: 6 × 5 + 8?\nChild: 38.\nParent: Лучший ответ?\nChild: третий.',
    readingSupport: 'Слово «источник» — по слогам.',
    russianSpeechGoal: 'Анита говорит: «ИИ помогает, человек проверяет.»',
    check: ['Анита исправила ответы ИИ.', 'Анита заполнила AI-check таблицу.'],
    spellingCheck: 'Проверить: ИИ, ответ, проверить, ошибка, источник.',
    readingCheck: 'Попытка русского чтения 5 фраз.',
    practicalCheck: 'AI-check таблица заполнена 4 полями.',
    discussionPrompts: ['Что может ошибаться в ответе ИИ?', 'Как проверить факт из ИИ?'],
    ifEasy: 'Придумать своё утверждение ИИ и заполнить таблицу.',
    ifDifficult: 'Оставить задачу 3 и таблицу.',
    commonMistakes: ['«ИИ всегда прав.» Правильно: ИИ может ошибаться.', '«Источник не нужен.» Правильно: источник обязателен.'],
    drawingCriteria: 'Карточка проверки ИИ с планом.',
    goal: 'Анита понимает, что ИИ помогает, но проверяет человек. Заполняет AI-check таблицу.',
    mathGoal: 'U.S. Grade 3: 50 − 38; 6 × 5 + 8; 3 × 12 + 9; сумма 3 баллов и лучший ответ.',
    russianGoal: 'Прочитать 5 слов и 5 фраз; написать 5 слов.',
    readingWritingGoal: 'Карточка проверки ИИ + 2 предложения.',
    parentTheoryCard: {
      title: 'Как проверять ответ ИИ',
      purpose: 'Показать 4 поля AI-check таблицы.',
      keyMessage: 'ИИ полезен, но правильность проверяет человек.',
      parentScript: [
        '«Что утверждается?»',
        '«Что надо проверить?»',
        '«Где проверить (какой источник поможет)?»',
        '«Можно ли сразу доверять? Обычно нет — проверяем.»'
      ],
      practiceSteps: ['Заполните AI-check таблицу вместе.', 'Обсудите: какой источник поможет.', 'Никаких настоящих поисков в интернете во время урока.'],
      paperOnlyNotes: ['Все задания на бумаге.', 'Никаких настоящих переходов по сайтам.'],
      doNotSay: ['Не давай готовые ответы для таблицы.', 'Не бросай ребёнка одного с ИИ.']
    },
    keyMessage: 'Точный вопрос, надёжный источник, факт с доказательством, проверка ИИ, опыт про плотность.',
    mathAnswerKey:
      'math-ai-fix: 50 − 38 = 12.\n' +
      'math-ai-groups: 6 × 5 = 30; 30 + 8 = 38.\n' +
      'math-ai-time: 3 × 12 = 36; 36 + 9 = 45.\n' +
      'math-best-answer: 8 + 6 + 10 = 24; лучший — третий (10).',
    spellingAnswerKey: 'ИИ\nответ\nпроверить\nошибка\nисточник',
    answerKey: [
      { taskId: 'reading-words', answer: '5 слов.' },
      { taskId: 'reading-sentences', answer: '5 фраз.' },
      { taskId: 'math-ai-fix', answer: '12.' },
      { taskId: 'math-ai-groups', answer: '30; 38.' },
      { taskId: 'math-ai-time', answer: '36; 45.' },
      { taskId: 'math-best-answer', answer: '24; третий.' },
      { taskId: 'logic-ai-check-table', answer: 'Что; что проверить; где; можно ли доверять — заполнено.' },
      { taskId: 'spelling-day4', answer: '5 слов.' },
      { taskId: 'creative-ai-card', answer: 'Карточка + 2 предложения плана.' },
      { taskId: 'speech-day4', answer: 'Идея ИИ + человек по-русски.' }
    ],
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за AI-check таблицу.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Никаких настоящих запросов к ИИ в уроке. Всё — на бумаге, только с родителем.',
    safetyNotes: 'Работа с ИИ — только с родителем. Никаких настоящих сайтов и не оставляй ребёнка одного с ИИ.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима', bonuses: [
    { id: 'clear-ai-check-table', label: 'Бонус за AI-check таблицу', amount: 1 }
  ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'math-ai-fix', 'math-ai-groups', 'math-ai-time', 'math-best-answer', 'logic-ai-check-table', 'spelling-day4', 'creative-ai-card', 'speech-day4'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-5-day-5'
};

export default day4;
